import request from '../utils/request'

export function login (data) {
  return request({
    url: '/api/auth/hlogin',
    method: 'post',
    data
  })
}
export function myinfo () {
  return request({
    url: '/api/member/myinfo',
    method: 'get'
  })
}
export function QiNiuToken () {
  return request({
    url: '/api/qiniu/token/',
    method: 'get'
  })
}
export function QiNiuPathSave (data) {
  return request({
    url: '/api/qiniu/path-save/',
    method: 'post',
    data
  })
}
export function saveFaceImage (data) {
  return request({
    url: '/api/face-image',
    method: 'post',
    headers: {'Content-type' : 'multipart/form-data'},
    data
  })
}
